import { Routes } from "@angular/router";
import { AppRoutes } from "./shared/common/app-path.routes";
import { CallBackComponentComponent } from "./Pages/login/call-back-component/call-back-component.component";
import { authGuard } from "./auth.guard";
import { LayoutComponent } from "./Pages/layout/layout.component";
import { loginGuard } from "./login.guard";
export const routes: Routes = [
  {
    path: AppRoutes.LoginCallback,
    component: CallBackComponentComponent,
  },

  { path: "login/callback", component: CallBackComponentComponent },
  {
    path: AppRoutes.Login,
    canMatch: [loginGuard],
    loadComponent: () =>
      import("./Pages/login/login.component").then((m) => m.LoginComponent),
    // pathMatch: "prefix",
  },
  {
    path: AppRoutes.InternalUserRegistration,
    canMatch: [loginGuard],
    loadComponent: () =>
      import("./Pages/login/internal-user-registration/internal-user-registration.component").then(
        (m) => m.InternalUserRegistrationComponent,
      ),
  },
  {
    path: AppRoutes.PageNotFound,
    loadComponent: () =>
      import("./Pages/login/page-not-found/page-not-found.component").then(
        (m) => m.PageNotFoundComponent,
      ),
  },
  {
    path: AppRoutes.Help,
    loadComponent: () =>
      import("./Pages/login/helpsection/helpsection.component").then(
        (m) => m.HelpsectionComponent,
      ),
  },
  {
    path: AppRoutes.Root,
    redirectTo: AppRoutes.Login,
    pathMatch: "full",
  },
  {
    path: AppRoutes.Dashboard,
    canMatch: [authGuard],
    component: LayoutComponent,
    children: [
      {
        path: AppRoutes.Root,
        loadComponent: () =>
          import("./Pages/home/home.component").then((m) => m.HomeComponent),
      },
      {
        path: AppRoutes.AdminDashboard,
        loadComponent: () =>
          import("./Pages/admin-dashboard/admin-dashboard.component").then(
            (m) => m.AdminDashboardComponent,
          ),
      },
      {
        path: AppRoutes.EditApp,
        loadComponent: () =>
          import("./Pages/admin-dashboard/add-edit-app/add-edit-app.component").then(
            (m) => m.AddEditAppComponent,
          ),
      },
      {
        path: AppRoutes.NotificationList,
        loadComponent: () =>
          import("./Pages/notification-list/notification-list.component").then(
            (m) => m.NotificationListComponent,
          ),
      },
      // {
      //   path: "**",
      //   loadComponent: () =>
      //     import("./Pages/login/page-not-found/page-not-found.component").then(
      //       (m) => m.PageNotFoundComponent,
      //     ),
      //   data: { variant: "private" },
      // }
    ],
  },
  {
    path: AppRoutes.PageNotFound,
    loadComponent: () =>
      import("./Pages/login/page-not-found/page-not-found.component").then(
        (m) => m.PageNotFoundComponent,
      ),
    data: { variant: "public" },
  },
  { path: "**", redirectTo: AppRoutes.PageNotFound },
];
